<template>
  <a-drawer width="20%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!--      <a-form-model-item label="类型" prop="type" >-->
      <!--        <a-select v-model="form.type" placeholder="请选择" disabled >-->
      <!--          <a-select-option :value="1">赠送比例</a-select-option>-->
      <!--          <a-select-option :value="2">赠送数量</a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="提现金额" prop="distmoney">
        <a-input-number :min="0" :max="this.maxMoney" v-model="form.distmoney" placeholder="请输入提现金额"/>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getDistribution, addDistribution, updateDistributionMoney} from '@/api/user/distribution'

export default {
  name: 'DisMoney',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      maxMoney: 0,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: null,
        distmoney: null,

        title: null,

        num: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {}
    }
  },
  filters: {},
  created() {
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    getData(record) {
      this.reset()
      this.formType = 2
      this.form = record
      this.maxMoney = record.distmoney
      console.log("分销金额", this.maxMoney)
      this.open = true
      this.formTitle = '修改'
    },
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        title: null,
        num: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDistribution({"id": id}).then(response => {
        this.form = response.data

        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          updateDistributionMoney({"userId": this.form.userId, "distmoney": this.form.distmoney}).then(response => {
            this.$message.success(
              '修改成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })

        } else {
          return false
        }
      })
    }
  }
}
</script>
